import type {SyllabusTerm} from "app/employee/state/syllabus/mutations";
import {DetailedProgress} from "app/employee/syllabus/DetailedProgress";
import {useTranslation} from "react-i18next";

interface Props {
  terms: SyllabusTerm[];
}

export const SyllabusCompletedTermPlan = ({terms}: Props) => {
  const {t} = useTranslation();
  const completedPlansWithTerm = terms
    .flatMap((t) => t.termPlans.map((tp) => ({term: t, termPlan: tp})))
    .filter((tp) => tp.termPlan.completed)
    .reverse();

  if (completedPlansWithTerm.length === 0) {
    return <h4>{t("syllabus.completed.no-completed", {defaultValue: "Няма завършени обучения"})}</h4>;
  } else {
    return <DetailedProgress plansWithTerm={completedPlansWithTerm} />;
  }
};
